import { useMemo } from 'react';

import {
  createReplacementEngine,
  iframeProcessor,
  imageProcessor,
} from '../../index';

interface UseReplacementEngineProps {
  content: string;
  displayThirdPartyConsent?: boolean;
  enableImagePreview?: boolean;
}

export const useReplacementEngine = ({
  content,
  displayThirdPartyConsent = false,
  enableImagePreview = false,
}: UseReplacementEngineProps) =>
  useMemo(() => {
    const replacementConfigs: Array<
      typeof iframeProcessor | typeof imageProcessor
    > = [];

    if (displayThirdPartyConsent) {
      replacementConfigs.push(iframeProcessor);
    }

    if (enableImagePreview) {
      replacementConfigs.push(imageProcessor);
    }

    const replacementEngine = createReplacementEngine(replacementConfigs);
    const result = replacementEngine(content);

    return {
      dangerouslySetInnerHTML: { __html: result.modifiedHtml },
      replacements: result.replacements,
    };
  }, [content, displayThirdPartyConsent, enableImagePreview]);
